// General site interactivity: header shrink-on-scroll, mobile menu, desktop overflow menu,
// language dropdown, expandable questions. getWidth/getHeight are exposed on window because
// other bundles (e.g. section-heights.js) rely on them.

function toggleMenu(element) {
  const labelMenuToggle = document.getElementById('label_menu_toggle');
  const data = element.dataset;

  if (element.checked) {
    labelMenuToggle.getElementsByTagName('span')[0].innerText = data.menuCloseLabel;
    labelMenuToggle.getElementsByTagName('img')[0].src = data.menuCloseIcon;
    document.getElementById('overlay').style.display = 'block';
    mobileMenuStyle();
  } else {
    labelMenuToggle.getElementsByTagName('span')[0].innerText = data.menuOpenLabel;
    labelMenuToggle.getElementsByTagName('img')[0].src = data.menuOpenIcon;
    document.getElementById('overlay').style.display = 'none';
  }
}

function mobileMenuStyle() {
  const offsetHeightScreen = window.innerHeight;
  const offsetHeightSubMenu = document.getElementById('menu-mobile').offsetHeight;

  if (offsetHeightScreen < offsetHeightSubMenu + 120) {
    document.getElementById('menu-mobile').style.overflow = 'scroll';
    document.getElementById('menu-mobile').style.maxHeight = '100vh';
    document.getElementById('menu-mobile').style.height = '100vh';
  }
}

function toggleSmall() {
  const header = document.getElementsByTagName('header')[0];

  if (window.scrollY >= 100) {
    header.classList.add('small');
  } else {
    header.classList.remove('small');
  }
}

function scrollMenu() {
  document.addEventListener('scroll', () => {
    toggleSmall();
  });
}

toggleSmall();
scrollMenu();

function initOverflowMenu() {
  const desktopMenu = document.querySelector('header .menu.desktop');

  if (!desktopMenu) {
    return;
  }

  const container = desktopMenu.querySelector('.container');

  if (!container) {
    return;
  }

  const more = container.querySelector('.overflow-more');

  if (!more) {
    return;
  }

  const moreList = more.querySelector('.overflow-more .list');

  if (!moreList) {
    return;
  }

  const moreToggle = more.querySelector('.nav-toggle');

  const moved = [];

  function closeMore() {
    more.classList.remove('is-open');

    if (moreToggle) {
      moreToggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (moreToggle) {
    moreToggle.addEventListener('click', (e) => {
      e.preventDefault();
      more.classList.toggle('is-open');
      moreToggle.setAttribute('aria-expanded', more.classList.contains('is-open') ? 'true' : 'false');
    });
  }

  document.addEventListener('click', (e) => {
    if (!more.classList.contains('d-none') && !more.contains(e.target)) {
      closeMore();
    }
  });

  function resetMovedItems() {
    while (moved.length) {
      const { wrapper } = moved.pop();
      container.insertBefore(wrapper, more);
    }

    moreList.innerHTML = '';
  }

  function isOverflowing() {
    const top = container.getBoundingClientRect().top;
    const children = Array.from(container.children).filter((el) => el.offsetParent !== null);
    const wrapped = children.some((el) => Math.abs(el.getBoundingClientRect().top - top) > 1);

    const tooWide = container.scrollWidth > container.clientWidth;

    return wrapped || tooWide;
  }

  function moveToMore(wrapper) {
    const btn = wrapper.querySelector('button.nav-toggle');
    const link = wrapper.querySelector('a.nav-link') || wrapper.querySelector('a');

    const label = (btn ? btn.childNodes[0].textContent : (link ? link.textContent : wrapper.textContent)).trim();

    const a = document.createElement('a');
    a.className = 'item';
    a.textContent = label;

    if (link && link.getAttribute('href')) {
      a.href = link.getAttribute('href');
    } else {
      a.href = '#';
      a.addEventListener('click', (e) => e.preventDefault());
    }

    moved.push({ wrapper });
    wrapper.remove();
    moreList.prepend(a);
  }

  function rebuild() {
    if (window.matchMedia('(max-width: 921px)').matches) {
      return;
    }

    closeMore();
    resetMovedItems();

    more.classList.remove('d-none');

    const normalItems = () =>
      Array.from(container.children).filter((el) =>
        el.classList.contains('nav-item') &&
        !el.classList.contains('overflow-more') &&
        el.offsetParent !== null
      );

    const meeting = container.querySelector('.meeting');
    const register = container.querySelector('.register');

    while (isOverflowing()) {
      const items = normalItems();

      if (items.length > 0) {
        moveToMore(items[items.length - 1]);
        continue;
      }

      if (meeting && meeting.offsetParent !== null) {
        moveToMore(meeting);
        continue;
      }

      if (register && register.offsetParent !== null) {
        moveToMore(register);
        continue;
      }

      break;
    }

    if (moreList.children.length === 0) {
      more.classList.add('d-none');
    }
  }

  let t;

  function schedule() {
    clearTimeout(t);
    t = setTimeout(rebuild, 60);
  }

  window.addEventListener('resize', schedule);
  rebuild();
}

function initOverlayClose() {
  const overlay = document.getElementById('overlay');

  if (!overlay) {
    return;
  }

  overlay.addEventListener('click', () => {
    const toggle = document.getElementById('menu_toggle');

    if (toggle && toggle.checked) {
      toggle.checked = false;
      toggle.dispatchEvent(new Event('change'));
    }
  });
}

function initLangDropdown() {
  const headers = document.querySelectorAll('.lang li.header');

  if (!headers.length) {
    return;
  }

  headers.forEach((header) => {
    header.addEventListener('click', (e) => {
      e.stopPropagation();
      header.classList.toggle('is-open');
    });
  });

  document.addEventListener('click', () => {
    headers.forEach((header) => header.classList.remove('is-open'));
  });
}

function initExpandableQuestions() {
  document.querySelectorAll('.questions.expandable .item.is-open .answer').forEach((answer) => {
    answer.style.maxHeight = answer.scrollHeight + 'px';
  });

  document.querySelectorAll('.questions.expandable .toggle').forEach((button) => {
    button.addEventListener('click', (event) => {
      const toggle = event.currentTarget;
      const item = toggle.closest('.item');
      const answer = item.querySelector('.answer');
      const icon = toggle.querySelector('.icon');
      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        answer.style.maxHeight = null;
        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        icon.src = icon.dataset.plus;
      } else {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        icon.src = icon.dataset.minus;
      }
    });
  });
}

function initMenuToggle() {
  const toggle = document.getElementById('menu_toggle');
  if (toggle) {
    toggle.addEventListener('change', () => toggleMenu(toggle));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initMenuToggle();
  initOverflowMenu();
  initLangDropdown();
  initOverlayClose();
  initExpandableQuestions();
});

function getWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

function getHeight() {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.documentElement.clientHeight
  );
}

window.getWidth = getWidth;
window.getHeight = getHeight;
